import api from '../utils/api';

const BASE = '/api/tags';

/**
 * Search tags by name.
 * @route GET /api/tags?search={query}
 * @param {string} query - Case-insensitive name filter
 * @returns {Promise<Object[]>} Matching tags
 */
export const searchTags = (query) =>
    api.get(BASE, { params: { search: query } }).then((r) => r.data);

/**
 * Get all tags with optional filters and sorting.
 * @route GET /api/tags
 * @param {{ search?: string, sortBy?: 'count'|'alpha'|'date', order?: 'asc'|'desc', unused?: 'true' }} [params]
 * @returns {Promise<Object[]>} Tags matching the filter
 */
export const getAllTags = (params = {}) =>
    api.get(BASE, { params }).then((r) => r.data);

/**
 * Delete a tag by id (admin only). Also strips the tag from all scenarios.
 * @route DELETE /api/tags/{tagId}
 * @param {string} tagId
 * @returns {Promise<{ message: string }>}
 */
export const deleteTag = (tagId) =>
    api.delete(`${BASE}/${tagId}`).then((r) => r.data);

/**
 * Delete all tags with usageCount=0 (admin only).
 * @route DELETE /api/tags/unused
 * @returns {Promise<{ deleted: number }>}
 */
export const deleteUnusedTags = () =>
    api.delete(`${BASE}/unused`).then((r) => r.data);

/**
 * Add a tag to a scenario by name (find-or-create).
 * @route POST /api/tags/scenario/{scenarioId}
 * @param {string} scenarioId
 * @param {string} name - Tag name
 * @param {string} userId
 * @returns {Promise<{ scenario: Object, tag: Object }>}
 */
export const addTagToScenario = (scenarioId, name, userId) =>
    api
        .post(`${BASE}/scenario/${scenarioId}`, { name }, {
            headers: { Authorization: `Bearer ${userId}` },
        })
        .then((r) => r.data);

/**
 * Remove a tag from a scenario.
 * @route DELETE /api/tags/scenario/{scenarioId}/{tagId}
 * @param {string} scenarioId
 * @param {string} tagId
 * @param {string} userId
 * @returns {Promise<{ scenario: Object }>}
 */
export const removeTagFromScenario = (scenarioId, tagId, userId) =>
    api
        .delete(`${BASE}/scenario/${scenarioId}/${tagId}`, {
            headers: { Authorization: `Bearer ${userId}` },
        })
        .then((r) => r.data);
